(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3Confirm', {
            templateUrl: 'app/shared/modals/confirm.component.html',
            bindings: {
                close: '&',
                dismiss: '&',
                resolve: '<'
            }
        });
})();